import React, { useState, useEffect } from 'react';
import {
  Dialog,
  BUTTON_VARIANTS,
  DialogContent,
  PrimaryButton,
} from 'cdk-radial';
import styled from 'styled-components';
import './APIs.css';
import axios from 'axios';
import { toDateStringFormat } from '../../../../../utils/utils';

const StyledDialog = styled(Dialog)`
  width: 120vw;
`;

export const APITerms = (props) => {
  const [termsDocFile, setTermsDocFile] = useState(null);
  const [termsFile, setTermsFile] = useState(null);

  const { isOpen, handleClose, data } = props;
  const { name, consent, bundle } = data;
  const resourceName = name ? name : bundle.name;
  const {
    signedTermsAndConditions: signedTerms,
    updatedDate: acceptedOn,
    name: acceptedBy,
    userEmail: email,
  } = consent ?? {};
  const TITLE = `Terms and Conditions - ${resourceName}`;

  const readBlob = (data) => {
    const file = new Blob([data], { type: 'application/pdf' });
    setTermsFile(file);
    setTermsDocFile(window.URL.createObjectURL(file));
  };

  const pullTerms = async (consentLink) => {
    if (consentLink) {
      await axios(consentLink, {
        params: {
          requestId: 1,
        },
        method: 'GET',
        responseType: 'blob',
      })
        .then((response) => {
          const data = response.data;
          readBlob(data);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  useEffect(() => {
    pullTerms(signedTerms);
  }, []);

  const handleDownload = (_) => {
    const link = document.createElement('a');
    link.href = termsDocFile;
    link.download = `${name}_accepted_consent.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(termsFile);
  };

  const renderCustomFooter = () => <div className="download-pdf-wrapper">
        <PrimaryButton
          className="download-pdf-button"
          text={'Download PDF'}
          onClick={handleDownload}
        />
      </div>

  return (
    <StyledDialog
      id="api-terms"
      title={TITLE}
      isOpen={isOpen}
      onClose={handleClose}
      disableOverlayClicked={true}
      renderCustomFooterComponent={renderCustomFooter}
      className="terms-dialog"
    >
      <div className='terms-dialog-details'>
      <div>Signed by: {acceptedBy}</div>
      <div>Date: {toDateStringFormat(acceptedOn)}</div>
      <div>Contact: {email}</div>
      </div>

      <DialogContent className={'terms-dialog-content'}>
        <iframe
          className="review-terms-doc"
          type="application/pdf"
          src={termsDocFile}
        />
      </DialogContent>
    </StyledDialog>
  );
};
